import PropertyPageContainer from './containers/PropertyPageContainer'

export default PropertyPageContainer
